export class EvaluationParamsCreator {
  createInitialData(idNumber, evaluationId, simulationData, userId) {
    const { simulation, verifiedSimulation } = simulationData;
    return {
      idNumber,
      userId,
      parentEvaluationId: evaluationId,
      simulation: verifiedSimulation || simulation
    };
  }

  createEvaluationParams({
    evaluationId,
    idNumber,
    userId,
    parentEvaluationId,
    simulation,
    income,
    debt,
    eligibility,
    userShortName = ''
  }) {
    return {
      id: evaluationId,
      idNumber,
      userId,
      userShortName,
      parentEvaluationId,
      simulation,
      income: {
        calculate: income
      },
      debt: {
        calculate: debt
      },
      eligibility
    };
  }

  createSimulationParams(simulationData) {
    const { simulation, verifiedSimulation } = simulationData || {};
    return verifiedSimulation || simulation;
  }
}
